import { render, staticRenderFns } from "./NewTerminal.vue?vue&type=template&id=033fb8c4&scoped=true&"
import script from "./NewTerminal.vue?vue&type=script&lang=js&"
export * from "./NewTerminal.vue?vue&type=script&lang=js&"
import style0 from "./NewTerminal.vue?vue&type=style&index=0&id=033fb8c4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "033fb8c4",
  null
  
)

export default component.exports